export interface BlogPost {
  id: string
  slug: string
  title: string
  excerpt: string
  content: string
  category: string
  author: string
  date: string
  readTime: string
  image: string
}

export const blogPosts: BlogPost[] = [
  {
    id: 'b1',
    slug: 'tendencias-videovigilancia-2025',
    title: '5 Tendências de Videovigilância para 2025',
    excerpt: 'Inteligência artificial, análise preditiva e integração em nuvem estão redefinindo a segurança corporativa.',
    content:
      'A videovigilância corporativa evoluiu de simples gravação para plataformas inteligentes capazes de prever incidentes antes que ocorram. Neste artigo, exploramos as cinco principais tendências que moldarão o setor em 2025, incluindo análise de vídeo por IA, integração com controle de acesso e monitoramento descentralizado via nuvem.',
    category: 'Videovigilância',
    author: 'Rafael Nogueira',
    date: '2025-01-14',
    readTime: '6 min',
    image: 'https://static.lumi.new/29/29efe632b45dee52e260de6f6c553441.png',
  },
  {
    id: 'b2',
    slug: 'normas-alarme-incendio-abnt',
    title: 'Entenda as Normas ABNT para Alarme de Incêndio',
    excerpt: 'Um guia completo sobre a NBR 17240 e como garantir a conformidade do seu edifício.',
    content:
      'A conformidade com a NBR 17240 é essencial para a aprovação do AVCB e para garantir a segurança de colaboradores e visitantes. Este guia detalha os principais requisitos técnicos, tipos de detectores e etapas do processo de certificação.',
    category: 'Alarme de Incêndio',
    author: 'Camila Rodrigues',
    date: '2025-01-02',
    readTime: '8 min',
    image: 'https://static.lumi.new/95/95d9ad5b77eb3ec7b80dfb06a462da75.png',
  },
  {
    id: 'b3',
    slug: 'controle-acesso-biometrico-vantagens',
    title: 'Controle de Acesso Biométrico: Vantagens para Empresas',
    excerpt: 'Como a biometria reduz custos operacionais e aumenta a segurança de edifícios corporativos.',
    content:
      'Sistemas biométricos eliminam fraudes com crachás e senhas, oferecendo rastreabilidade total de acesso. Analisamos casos reais de empresas que reduziram custos operacionais após a adoção dessa tecnologia.',
    category: 'Controle de Acesso',
    author: 'Eduardo Martins',
    date: '2024-12-18',
    readTime: '5 min',
    image: 'https://static.lumi.new/7e/7ea895769e90f745c75d967d28134565.png',
  },
  {
    id: 'b4',
    slug: 'rede-corporativa-alta-disponibilidade',
    title: 'Como Projetar Redes Corporativas de Alta Disponibilidade',
    excerpt: 'Estratégias de redundância e monitoramento para eliminar pontos únicos de falha.',
    content:
      'A alta disponibilidade de rede é crítica para operações que não podem parar. Discutimos arquiteturas redundantes, links dedicados e práticas de monitoramento contínuo aplicadas em nossos projetos hospitalares e industriais.',
    category: 'Redes e Telecom',
    author: 'Beatriz Andrade',
    date: '2024-12-05',
    readTime: '7 min',
    image: 'https://static.lumi.new/95/95d9ad5b77eb3ec7b80dfb06a462da75.png',
  },
  {
    id: 'b5',
    slug: 'consultoria-integrada-reducao-custos',
    title: 'Consultoria Integrada: Como Reduzir Custos de Segurança',
    excerpt: 'Unificar sistemas de segurança pode reduzir custos operacionais em até 40%.',
    content:
      'Empresas com múltiplas plantas ou unidades frequentemente sofrem com sistemas de segurança desconexos. Explicamos como uma abordagem de consultoria integrada unifica plataformas e reduz custos operacionais significativamente.',
    category: 'Consultoria',
    author: 'Eduardo Martins',
    date: '2024-11-20',
    readTime: '6 min',
    image: 'https://static.lumi.new/29/29efe632b45dee52e260de6f6c553441.png',
  },
  {
    id: 'b6',
    slug: 'alarme-intrusao-perimetral-tecnologias',
    title: 'Tecnologias de Alarme Perimetral: Qual Escolher?',
    excerpt: 'Comparamos sensores de dupla tecnologia, cercas inteligentes e barreiras de micro-ondas.',
    content:
      'A escolha da tecnologia de detecção perimetral depende do perfil de risco e da área a ser protegida. Analisamos as principais opções disponíveis no mercado e seus casos de uso ideais.',
    category: 'Alarmes de Intrusão',
    author: 'Rafael Nogueira',
    date: '2024-11-08',
    readTime: '5 min',
    image: 'https://static.lumi.new/b0/b03951c1cd78876768df64078b9174bf.png',
  },
]
